/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link, Switch, Redirect, useLocation } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { ContentRoute } from "../../../../_metronic/layout"
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import Login from "./Login";
import Registration from "./Registration";
import ForgotPassword from "./ForgotPassword";
import ResetPassword from "./ResetPassword";
import LegalPage from "../../Other/pages/LegalPage";
import PrivacyPage from "../../Other/pages/PrivacyPage";
import ContactPage from "../../Other/pages/ContactPage";
import HelpcenterPage from "../../Other/pages/HelpcenterPage";
import "../../../../_metronic/_assets/sass/pages/login/login-3.scss";
import { QueryClient, QueryClientProvider } from "react-query";

export function AuthPage() {
  const location = useLocation();

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  return (
    <>
      <div className="d-flex flex-column flex-root">
        {/*begin::Login*/}
        <div
          className="login login-3 login-signin-on d-flex flex-column flex-lg-row flex-row-fluid bg-white"
          id="kt_login"
        >
          {/*begin::Aside*/}
          <div
            className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10"
            style={{
              backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-2.jpg")})`
            }}
          >
            {/*begin: Aside Container*/}
            <div className="d-flex flex-row-fluid flex-column justify-content-between">
              {/* start:: Aside header */}
              <Link to="/" className="flex-column-auto my-5">
                <img
                  alt="Arhiva Logo"
                  className="max-h-70px"
                  src={toAbsoluteUrl("/media/logos/logo-arhiva.png")}
                />
              </Link>
              {/* end:: Aside header */}

              {/* start:: Aside content */}
              <div className="flex-column-fluid d-flex flex-column justify-content-center">
                <h3 className="font-size-h1 mb-5 text-white">
                  <FormattedMessage id="AUTH.GENERAL.WELCOME" />
                </h3>
                <p className="font-weight-lighter text-white opacity-80">
                  <FormattedMessage id="AUTH.GENERAL.WELCOME.DESC" />
                </p>
              </div>
              {/* end:: Aside content */}

              {/* start:: Aside footer for desktop */}
              <div className="d-none flex-column-auto d-lg-flex justify-content-between mt-10">
                <div className="opacity-70 font-weight-bold	text-white">
                  <FormattedHTMLMessage id="GENERAL.COPYRIGHT" />
                </div>
                <div className="d-flex">
                  <Link to="/privacy" className="text-white">
                    <FormattedMessage id="MENU.PRIVACY" />
                  </Link>
                  <Link to="/legal" className="text-white ml-10">
                    <FormattedMessage id="MENU.LEGAL" />
                  </Link>
                  <Link to="/contact" className="text-white ml-10">
                    <FormattedMessage id="MENU.CONTACT" />
                  </Link>
                </div>
              </div>
              {/* end:: Aside footer for desktop */}
            </div>
            {/*end: Aside Container*/}
          </div>
          {/*begin::Aside*/}

          {/*begin::Content*/}
          <div className="flex-row-fluid d-flex flex-column position-relative p-7 overflow-hidden container-fluid">

            {/* begin::Content body */}
            <div className={`${location.pathname.includes('auth') && 'd-flex mt-30 '} flex-column-fluid flex-center mt-lg-0`}>
              <QueryClientProvider client={queryClient}>
                <Switch>
                  <ContentRoute path="/legal" component={LegalPage} />
                  <ContentRoute path="/privacy" component={PrivacyPage} />
                  <ContentRoute path="/contact" component={ContactPage} />
                  <ContentRoute path="/helpcenter" component={HelpcenterPage} />
                  <ContentRoute path="/auth/login" component={Login} />
                  <ContentRoute path="/auth/registration" component={Registration} />
                  <ContentRoute path="/auth/forgot-password" component={ForgotPassword} />
                  <ContentRoute path="/auth/reset-password" component={ResetPassword} />
                  <Redirect from="/auth" exact={true} to="/auth/login" />
                  <Redirect to="/auth/login" />
                </Switch>
              </QueryClientProvider>
            </div>
            {/*end::Content body*/}

            {/* begin::Mobile footer */}
            <div
              className="d-flex d-lg-none flex-column-auto flex-column flex-sm-row justify-content-between align-items-center mt-5 p-5">
              <div className="text-dark-50 font-weight-bold order-2 order-sm-1 my-2">
                <FormattedHTMLMessage id="GENERAL.COPYRIGHT" />
              </div>
              <div className="d-flex order-1 order-sm-2 my-2">
                <Link to="/privacy" className="text-dark-75 text-hover-primary">
                  <FormattedMessage id="MENU.PRIVACY" />
                </Link>
                <Link to="/legal" className="text-dark-75 text-hover-primary ml-4">
                  <FormattedMessage id="MENU.LEGAL" />
                </Link>
                <Link to="/contact" className="text-dark-75 text-hover-primary ml-4">
                  <FormattedMessage id="MENU.CONTACT" />
                </Link>
              </div>
            </div>
            {/* end::Mobile footer */}
          </div>
          {/*end::Content*/}
        </div>
        {/*end::Login*/}
      </div>
    </>
  );
}
